module.exports = "{% extends 'base.html.twig' %}\n\n{% block title %}Movie list{% endblock %}\n\n{% block body %}\n    {% for movie in movies %}\n        <div class=\"movie\"/>\n            <h2><a href=\"/movie/{{movie.id}}\">{{ movie.name }}</a></h2>\n            <p>{{ movie.director }}</p>\n            <p>{{ movie.year }}</p>\n            <img src=\"/images/{{movie.picture}}\">\n        </div>\n    {% else %}\n        There are no movies.\n    {% endfor %}\n{% endblock %}"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/template-movies-1.txt
// module id = 660
// module chunks = 166022795811749